<template>
   <div>
      <Buscador />
   </div>
</template>

<script>
import Buscador from "../components/Buscador.vue";

export default {
   components: {
      Buscador,
   },
   data: () => ({
      //
   }),
};
</script>